<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
      <c-table
        ref="table"
        :title="title"
        tableId="table"
        :columnSetting="false"
        :isFullScreen="false"
        :columns="grid.columns"
        :data="grid.data"
        @rowClick="rowClick"
        :isExcelDown="false"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <!-- <c-btn label="검색" icon="search" @btnClicked="getEnvList" /> -->
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
      <q-form ref="editForm">
        <c-card title="상세" class="cardClassDetailForm">
          <template slot="card-button">
            <q-btn-group outline >
              <c-btn v-if="editable" label="신규" icon="add" @btnClicked="addEnv" />
              <c-btn
                v-if="editable && saveable"
                :url="saveUrl"
                :isSubmit="isSave"
                :param="data"
                :mappingType="saveType"
                label="저장"
                icon="save"
                @beforeAction="saveEnv"
                @btnCallback="saveCallback" />
              <c-btn
                v-if="editable && deleteable"
                :url="deleteUrl"
                :isSubmit="true"
                :param="data"
                mappingType="DELETE"
                label="삭제"
                icon="remove"
                @beforeAction="deleteEnv"
                @btnCallback="deleteCallback" />
            </q-btn-group>
          </template>
          <template slot="card-detail">
            <div class="col-4">
              <c-datepicker
                :required="true"
                :editable="editable && dataeditable"
                label="실시일자"
                name="execDt"
                v-model="data.execDt"
                />
            </div>
            <div class="col-4">
              <c-field 
                :required="true"
                :editable="editable && dataeditable"
                :disabled="!editable && !dataeditable"
                :data="data"
                deptValue="deptCd"
                type="dept_user" 
                label="대관업무 실시자" 
                name="execUserId" 
                v-model="data.execUserId" />
            </div>
            <div class="col-12">
              <c-textarea
                :editable="editable && dataeditable"
                label="업무내용"
                name="remarks"
                :rows="6"
                v-model="data.remarks">
              </c-textarea>
            </div>
            <div class="col-12">
              <c-upload
                :attachInfo="attachInfo"
                :editable="editable && dataeditable"
                label="대관업무 실시 첨부파일">
              </c-upload>
            </div>
          </template>
        </c-card>
      </q-form>
    </div>
  </div>
</template>
<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'gov-schedule-info',
  props: {
    param: {
      type: Object,
      default: () => ({
        govScheduleMstId: '',
      }),
    },
  },
  data() {
    return {
      title: '',
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'GOV_SCHEDULE_HISTORY',
        taskKey: '',
      },
      grid: {
        columns: [
          {
            name: 'execDt',
            field: 'execDt',
            label: '대관업무 실시일자',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '대관업무 실시자 부서',
            align: 'center',
            sortable: true,
          },
          {
            name: 'execUserName',
            field: 'execUserName',
            label: '대관업무 실시자',
            align: 'center',
            sortable: true,
          },
        ],
        data: [],
      },
      data: {
        govScheduleHistoryId: '',  // 대관업무 이력 일련번호
        govScheduleMstId: '',  // 대관업무 마스터 일련번호
        execDt: '',  // 실시일자
        execUserId: '',  // 대관업무 실시자
        remarks: '',  // 내용
      },
      listUrl: '',
      detailUrl: '',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      saveable: false,
      deleteable: false,
      dataeditable: false,
      editable: true,
      updateMode: false,
      isSave: false,
      saveUrl: transactionConfig.env.gov.history.insert.url,
      saveType: 'POST',
      searchUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.dataeditable = false;
      // api scope
      this.listUrl = selectConfig.env.gov.history.list.url;
      this.detailUrl = selectConfig.env.gov.history.get.url;
      this.insertUrl = transactionConfig.env.gov.history.insert.url;
      this.updateUrl = transactionConfig.env.gov.history.update.url;
      this.deleteUrl = transactionConfig.env.gov.history.delete.url;
      this.getDetail();
      this.getList();
    },
    getDetail() {
      if (this.param.govScheduleMstId) {
        this.$http.url = selectConfig.env.gov.mst.get.url;
        this.$http.param = {govScheduleMstId: this.param.govScheduleMstId}
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.title = '대관업무 이력 ('+_result.data.govScheduleTypeName+' > '+_result.data.govScheduleName+')'
        },);
      }
    },
    rowRemoveSelect() {
      var _table = document.getElementsByClassName('bg-light-blue-1')[0];
      if (_table) {
        _table.classList.remove('bg-light-blue-1');
      }
    },
    getEnvList() {
      this.getList();
      this.rowRemoveSelect();
      this.reset();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {govScheduleMstId: this.param.govScheduleMstId};
      this.$http.request((_result) => {
        this.grid.data = _result.data;
        this.reset();
      },);
      this.saveable = false;
      this.deleteable = false;
    },
    rowClick(row) {
      // 상세조회
      this.saveable = true;
      this.deleteable = true;
      this.updateMode = true;
      this.dataeditable = true;
      this.$http.url = this.detailUrl;
      this.$http.param = {govScheduleHistoryId: row.govScheduleHistoryId};
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data = _result.data;
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
        this.$set(this.attachInfo, 'taskKey', row.govScheduleHistoryId)
      },
      () => {
      });
    },
    addEnv() {
      this.saveable = true;
      this.deleteable = false;
      this.saveUrl = this.insertUrl;
      this.saveType = 'POST';
      this.updateMode = false;
      this.dataeditable = true;
      this.data = {
        govScheduleHistoryId: '',  // 대관업무 이력 일련번호
        govScheduleMstId: this.param.govScheduleMstId,  // 대관업무 마스터 일련번호
        execDt: '',  // 실시일자
        execUserId: this.$store.getters.user.userId,  // 대관업무 실시자
        remarks: '',  // 내용
      };
      this.rowRemoveSelect();
      this.$set(this.attachInfo, 'taskKey', '')
    },
    reset() {
      this.rowRemoveSelect();
      this.saveable = false;
      this.deleteable = false;
      this.updateMode = false;
      this.dataeditable = false;
      this.data = {
        govScheduleHistoryId: '',  // 대관업무 이력 일련번호
        govScheduleMstId: '',  // 대관업무 마스터 일련번호
        execDt: '',  // 실시일자
        execUserId: '',  // 대관업무 실시자
        remarks: '',  // 내용
      };
    },
    saveEnv() {
      this.$refs['editForm'].validate().then(_result => {
        // 중복체크
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    deleteEnv() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.data.govScheduleHistoryId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.isSave = !this.isSave;
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (this.saveType == 'PUT') {
        this.getList();
        this.rowClick({ govScheduleHistoryId: result.data.govScheduleHistoryId })
      } else {
        this.$set(this.attachInfo, 'taskKey', result.data.govScheduleHistoryId)
        this.$set(this.attachInfo, 'isSubmit', uid())
        this.getEnvList();
      }
    },
    deleteCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getEnvList();
    },
  }
};
</script>